import AxiosInstance from "../config/AxiosInstance";

export const getSockHolding = async (page: any, limit: any, filters: any, location: any, companyId: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/stock/list', {
            params: {
                page: page,
                limit: limit,
                searchSupplier: filters.searchSupplier,
                searchSku: filters.searchSku,
                searchProductName: filters.searchProductName,
                searchUOM: filters.searchUOM,
                searchCost: filters.searchCost,
                searchQty: filters.searchQty,
                searchLineCost: filters.searchLineCost,
                searchInUse: filters.searchInUse,
                companyId: companyId,
                location: location
            }
        });
        return { data };
    } catch (error) {
        console.error('Error fetching countries:', error);
        throw error;
    }
};